// startup
// Load entry module and return exports
__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
__webpack_require__("./node_modules/immutable/dist/immutable.es.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/react/index.js");
__webpack_require__("./node_modules/react-dom/index.js");
__webpack_require__("./node_modules/react-redux/es/index.js");
var __webpack_exports__ = __webpack_require__("./node_modules/redux/es/redux.js");
